import * as FlatModels from '@medsurf/flat-models';
import type { Params } from '@angular/router';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  Reset = '[STORE | AUTHOR | SLIDE] Reset',
  SetTheme = '[STORE | AUTHOR | SLIDE] Set Theme',
  SetLayout = '[STORE | AUTHOR | SLIDE] Set Layout',
  DisableEditors = '[STORE | AUTHOR | SLIDE] Disable Editors',
  GoToSlideByNode = '[STORE | AUTHOR | SLIDE] Go To Slide By Node',
  GoToSlideByIndex = '[STORE | AUTHOR | SLIDE] Go To Slide By Index',
  SetMediaPanelSize = '[STORE | AUTHOR | SLIDE] Set Media Panel Size',
  CollapseMedia = '[STORE | AUTHOR | SLIDE] Collapse Media',
  SetChapterPanelSize = '[STORE | AUTHOR | SLIDE] Set Chapter Panel Size',
  CollapseChapter = '[STORE | AUTHOR | SLIDE] Collapse Chapter',
  SetLayerPanelSize = '[STORE | AUTHOR | SLIDE] Set Layer Panel Size',
  CollapseLayer = '[STORE | AUTHOR | SLIDE] Collapse Layer',
  SetWysiwygPanelSize = '[STORE | AUTHOR | SLIDE] Set Wysiwyg Panel Size',
  CollapseWysiwyg = '[STORE | AUTHOR | SLIDE] Collapse Wysiwyg',
  SetEditPanelSize = '[STORE | AUTHOR | SLIDE] Set Edit Panel Size',
  CollapseEdit = '[STORE | AUTHOR | SLIDE] Collapse Edit',
  AddTypedNodeExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Node Expanded',
  SetTypedNodeExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Node Expanded',
  AddTypedPageExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Page Expanded',
  SetTypedPageExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Page Expanded',
  AddTypedSlideLayersExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Slide Layers Expanded',
  SetTypedSlideLayersExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Slide Layers Expanded',
  AddTypedSlideAnnotationsExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Slide Annotations Expanded',
  SetTypedSlideAnnotationsExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Slide Annotations Expanded',
  AddTypedSlideGroupsExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Slide Groups Expanded',
  SetTypedSlideGroupsExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Slide Groups Expanded',
  AddTypedSlidePoisExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Slide Pois Expanded',
  SetTypedSlidePoisExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Slide Pois Expanded',
  AddTypedSlideQuestionsExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Slide Questions Expanded',
  SetTypedSlideQuestionsExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Slide Questions Expanded',
  AddTypedLayerExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Layer Expanded',
  SetTypedLayerExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Layer Expanded',
  AddTypedImageExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Image Expanded',
  SetTypedImageExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Image Expanded',
  AddTypedImageAnnotationExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Image Annotation Expanded',
  SetTypedImageAnnotationExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Image Annotation Expanded',
  AddTypedImagePoiExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Image Poi Expanded',
  SetTypedImagePoiExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Image Poi Expanded',
  AddTypedGroupExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Group Expanded',
  SetTypedGroupExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Group Expanded',
  AddTypedPoiExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Poi Expanded',
  SetTypedPoiExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Poi Expanded',
  AddTypedPoiAnnotationExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Poi Annotation Expanded',
  SetTypedPoiAnnotationExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Poi Annotation Expanded',
  AddTypedQuestionExpanded = '[STORE | AUTHOR | SLIDE] Add Typed Question Expanded',
  SetTypedQuestionExpanded = '[STORE | AUTHOR | SLIDE] Set Typed Question Expanded',
  AddMarkerWithPosition = '[STORE | AUTHOR | SLIDE] Add Marker With Position',
  UpdateMarkerAddTargetWithPosition = '[STORE | AUTHOR | SLIDE] Update Marker Add Target With Position',
  AddFreeFormWithPosition = '[STORE | AUTHOR | SLIDE] Add Free Form With Position',
  AddKeymapWithPosition = '[STORE | AUTHOR | SLIDE] Add Keymap With Position',
  AddTextWithPosition = '[STORE | AUTHOR | SLIDE] Add Text With Position',
  UpdateAnnotationPosition = '[STORE | AUTHOR | SLIDE] Update Annotation Position',
  CopyAnnotationWithPosition = '[STORE | AUTHOR | SLIDE] Copy Annotation With Position',
  ScrollNodeTreeElementIntoView = '[STORE | AUTHOR | SLIDE] Scroll Node Into View',
  ScrollSlideTreeElementIntoView = '[STORE | AUTHOR | SLIDE] Scroll Slide Element Into View',
  ActivateDrawTool = '[STORE | AUTHOR | SLIDE] Activate Draw Tool',
  GoHome = '[STORE | AUTHOR | SLIDE] Go Home',
  GoToAnnotation = '[STORE | AUTHOR | SLIDE] Go To Annotation',
  GoToPoi = '[STORE | AUTHOR | SLIDE] Go To Poi',
  AddPoiWithPosition = '[STORE | AUTHOR | SLIDE] Add Poi With Position',
  UpdatePoiPosition = '[STORE | AUTHOR | SLIDE] Update Poi Position',
  SetEditPanelOverlay = '[STORE | AUTHOR | SLIDE] Set Edit Panel Overlay',
  SetEditPanelDisplay = '[STORE | AUTHOR | SLIDE] Set Edit Panel Display',
  SetMainPanelDisplay = '[STORE | AUTHOR | SLIDE] Set Main Panel Display',
  SetIsSplitterMoving = '[STORE | AUTHOR | SLIDE] Set Is Splitter Moving',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Reset
 */
export class Reset {
  public static readonly type = ActionTypes.Reset;
}

/**
 * Set Theme
 */
export class SetTheme {
  public static readonly type = ActionTypes.SetTheme;
  
  public constructor(public theme: FlatModels.SlideAuthorModels.MedsurfTheme) {
  }
}

/**
 * Set Layout
 */
export class SetLayout {
  public static readonly type = ActionTypes.SetLayout;
  
  public constructor(public layout: 'list' | 'grid') {
  }
}

/**
 * Disable Editors
 */
export class DisableEditors {
  public static readonly type = ActionTypes.DisableEditors;
  
  public constructor(public id: string) {
  }
}

/**
 * Go To Slide By Node
 */
export class GoToSlideByNode {
  public static readonly type = ActionTypes.GoToSlideByNode;

  public constructor(public slideNode: FlatModels.NodeEntityModels.SlideNode,
                     public queryParams: Params) {
  }
}

/**
 * Go To Slide By Index
 */
export class GoToSlideByIndex {
  public static readonly type = ActionTypes.GoToSlideByIndex;

  public constructor(public index: number) {
  }
}

/**
 * Set Media Panel Size
 */
export class SetMediaPanelSize {
  public static readonly type = ActionTypes.SetMediaPanelSize;

  public constructor(public sizes: number[]) {
  }
}

/**
 * Collapse Media
 */
export class CollapseMedia {
  public static readonly type = ActionTypes.CollapseMedia;
  
  public constructor(public isMinimized: boolean,
                     public override: boolean) {
  }
}

/**
 * Set Chapter Panel Size
 */
export class SetChapterPanelSize {
  public static readonly type = ActionTypes.SetChapterPanelSize;

  public constructor(public sizes: number[]) {
  }
}

/**
 * Collapse Chapter
 */
export class CollapseChapter {
  public static readonly type = ActionTypes.CollapseChapter;

  public constructor(public isMinimized: boolean,
                     public override: boolean) {
  }
}

/**
 * Set Layer Panel Size
 */
export class SetLayerPanelSize {
  public static readonly type = ActionTypes.SetLayerPanelSize;

  public constructor(public sizes: number[]) {
  }
}

/**
 * Collapse Layer
 */
export class CollapseLayer {
  public static readonly type = ActionTypes.CollapseLayer;

  public constructor(public isMinimized: boolean,
                     public override: boolean) {
  }
}

/**
 * Set Wysiwyg Panel Size
 */
export class SetWysiwygPanelSize {
  public static readonly type = ActionTypes.SetWysiwygPanelSize;

  public constructor(public sizes: number[]) {
  }
}

/**
 * Collapse Wysiwyg
 */
export class CollapseWysiwyg {
  public static readonly type = ActionTypes.CollapseWysiwyg;

  public constructor(public isMinimized: boolean,
                     public override: boolean) {
  }
}

/**
 * Set Edit Panel Size
 */
export class SetEditPanelSize {
  public static readonly type = ActionTypes.SetEditPanelSize;

  public constructor(public sizes: number[]) {
  }
}

/**
 * Collapse Edit
 */
export class CollapseEdit {
  public static readonly type = ActionTypes.CollapseEdit;

  public constructor(public isMinimized: boolean,
                     public override: boolean) {
  }
}

/**
 * Add Typed Node Expanded
 */
export class AddTypedNodeExpanded {
  public static readonly type = ActionTypes.AddTypedNodeExpanded;

  public constructor(public nodeId: string) {
  }
}

/**
 * Set Typed Node Expanded
 */
export class SetTypedNodeExpanded {
  public static readonly type = ActionTypes.SetTypedNodeExpanded;

  public constructor(public typedNodeExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Page Expanded
 */
export class AddTypedPageExpanded {
  public static readonly type = ActionTypes.AddTypedPageExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Page Expanded
 */
export class SetTypedPageExpanded {
  public static readonly type = ActionTypes.SetTypedPageExpanded;

  public constructor(public typedPageExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Slide Layers Expanded
 */
export class AddTypedSlideLayersExpanded {
  public static readonly type = ActionTypes.AddTypedSlideLayersExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Slide Layers Expanded
 */
export class SetTypedSlideLayersExpanded {
  public static readonly type = ActionTypes.SetTypedSlideLayersExpanded;

  public constructor(public typedSlideLayersExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Slide Annotations Expanded
 */
export class AddTypedSlideAnnotationsExpanded {
  public static readonly type = ActionTypes.AddTypedSlideAnnotationsExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Slide Annotations Expanded
 */
export class SetTypedSlideAnnotationsExpanded {
  public static readonly type = ActionTypes.SetTypedSlideAnnotationsExpanded;

  public constructor(public typedSlideAnnotationsExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Slide Groups Expanded
 */
export class AddTypedSlideGroupsExpanded {
  public static readonly type = ActionTypes.AddTypedSlideGroupsExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Slide Groups Expanded
 */
export class SetTypedSlideGroupsExpanded {
  public static readonly type = ActionTypes.SetTypedSlideGroupsExpanded;

  public constructor(public typedSlideGroupsExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Slide Pois Expanded
 */
export class AddTypedSlidePoisExpanded {
  public static readonly type = ActionTypes.AddTypedSlidePoisExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Slide Pois Expanded
 */
export class SetTypedSlidePoisExpanded {
  public static readonly type = ActionTypes.SetTypedSlidePoisExpanded;

  public constructor(public typedSlidePoisExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Slide Questions Expanded
 */
export class AddTypedSlideQuestionsExpanded {
  public static readonly type = ActionTypes.AddTypedSlideQuestionsExpanded;

  public constructor(public pageId: string) {
  }
}

/**
 * Set Typed Slide Questions Expanded
 */
export class SetTypedSlideQuestionsExpanded {
  public static readonly type = ActionTypes.SetTypedSlideQuestionsExpanded;

  public constructor(public typedSlideQuestionsExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Layer Expanded
 */
export class AddTypedLayerExpanded {
  public static readonly type = ActionTypes.AddTypedLayerExpanded;

  public constructor(public layerId: string) {
  }
}

/**
 * Set Typed Layer Expanded
 */
export class SetTypedLayerExpanded {
  public static readonly type = ActionTypes.SetTypedLayerExpanded;

  public constructor(public typedLayerExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Image Expanded
 */
export class AddTypedImageExpanded {
  public static readonly type = ActionTypes.AddTypedImageExpanded;

  public constructor(public imageId: string) {
  }
}

/**
 * Set Typed Image Expanded
 */
export class SetTypedImageExpanded {
  public static readonly type = ActionTypes.SetTypedImageExpanded;

  public constructor(public typedImageExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Image Annotation Expanded
 */
export class AddTypedImageAnnotationExpanded {
  public static readonly type = ActionTypes.AddTypedImageAnnotationExpanded;
  
  public constructor(public annotationId: string) {
  }
}

/**
 * Set Typed Image Annotation Expanded
 */
export class SetTypedImageAnnotationExpanded {
  public static readonly type = ActionTypes.SetTypedImageAnnotationExpanded;
  
  public constructor(public typedImageAnnotationExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Image Poi Expanded
 */
export class AddTypedImagePoiExpanded {
  public static readonly type = ActionTypes.AddTypedImagePoiExpanded;

  public constructor(public poiId: string) {
  }
}

/**
 * Set Typed Image Poi Expanded
 */
export class SetTypedImagePoiExpanded {
  public static readonly type = ActionTypes.SetTypedImagePoiExpanded;

  public constructor(public typedImagePoiExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Group Expanded
 */
export class AddTypedGroupExpanded {
  public static readonly type = ActionTypes.AddTypedGroupExpanded;

  public constructor(public groupId: string) {
  }
}

/**
 * Set Typed Group Expanded
 */
export class SetTypedGroupExpanded {
  public static readonly type = ActionTypes.SetTypedGroupExpanded;

  public constructor(public typedGroupExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Poi Expanded
 */
export class AddTypedPoiExpanded {
  public static readonly type = ActionTypes.AddTypedPoiExpanded;

  public constructor(public poiId: string) {
  }
}

/**
 * Set Typed Poi Expanded
 */
export class SetTypedPoiExpanded {
  public static readonly type = ActionTypes.SetTypedPoiExpanded;

  public constructor(public typedPoiExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Poi Annotation Expanded
 */
export class AddTypedPoiAnnotationExpanded {
  public static readonly type = ActionTypes.AddTypedPoiAnnotationExpanded;

  public constructor(public annotationId: string) {
  }
}

/**
 * Set Typed Poi Annotation Expanded
 */
export class SetTypedPoiAnnotationExpanded {
  public static readonly type = ActionTypes.SetTypedPoiAnnotationExpanded;

  public constructor(public typedPoiAnnotationExpanded: { [id: string]: boolean }) {
  }
}

/**
 * Add Typed Question Expanded
 */
export class AddTypedQuestionExpanded {
  public static readonly type = ActionTypes.AddTypedQuestionExpanded;
  
  public constructor(public questionId: string) {
  }
}

/**
 * Set Typed Question Expanded
 */
export class SetTypedQuestionExpanded {
  public static readonly type = ActionTypes.SetTypedQuestionExpanded;
  
  public constructor(public typedQuestionExpanded: { [id: string]: boolean }) {
  }
}


/**
 * Add Marker With Position
 */
export class AddMarkerWithPosition {
  public static readonly type = ActionTypes.AddMarkerWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image | null,
                     public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest | null,
                     public tipType: FlatModels.AnnotationEntityModels.TipType,
                     public text: string | null,
                     public name: string) {
  }
}


/**
 * Update Marker Add Target With Position
 */
export class UpdateMarkerAddTargetWithPosition {
  public static readonly type = ActionTypes.UpdateMarkerAddTargetWithPosition;
  
  public constructor(public marker: FlatModels.AnnotationEntityModels.Marker) {
  }
}

/**
 * Add Free Form With Position
 */
export class AddFreeFormWithPosition {
  public static readonly type = ActionTypes.AddFreeFormWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image | null,
                     public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest | null,
                     public shape: FlatModels.AnnotationEntityModels.Shape,
                     public text: string | null,
                     public name: string) {
  }
}

/**
 * Add Keymap With Position
 */
export class AddKeymapWithPosition {
  public static readonly type = ActionTypes.AddKeymapWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image | null,
                     public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest | null,
                     public text: string | null,
                     public name: string) {
  }
}

/**
 * Add Text With Position
 */
export class AddTextWithPosition {
  public static readonly type = ActionTypes.AddTextWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image | null,
                     public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest | null,
                     public text: string | null,
                     public name: string) {
  }
}

/**
 * Update Annotation Position
 */
export class UpdateAnnotationPosition {
  public static readonly type = ActionTypes.UpdateAnnotationPosition;
  
  public constructor(public annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType) {
  }
}

/**
 * Copy Annotation With Position
 */
export class CopyAnnotationWithPosition {
  public static readonly type = ActionTypes.CopyAnnotationWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image) {
  }
}

/**
 * Scroll Node Tree Element Into View
 */
export class ScrollNodeTreeElementIntoView {
  public static readonly type = ActionTypes.ScrollNodeTreeElementIntoView;
  
  public constructor(public id: string) {
  }
}

/**
 * Scroll Slide Tree Element Into View
 */
export class ScrollSlideTreeElementIntoView {
  public static readonly type = ActionTypes.ScrollSlideTreeElementIntoView;
  
  public constructor(public id: string) {
  }
}

/**
 * Activate Draw Tool
 */
export class ActivateDrawTool {
  public static readonly type = ActionTypes.ActivateDrawTool;
  
  public constructor(public freeForm: FlatModels.AnnotationEntityModels.FreeForm) {
  }
}

/**
 * Go Home
 */
export class GoHome {
  public static readonly type = ActionTypes.GoHome;
}

/**
 * Go To Annotation
 */
export class GoToAnnotation {
  public static readonly type = ActionTypes.GoToAnnotation;
  
  public constructor(public annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType) {
  }
}

/**
 * Go To Poi
 */
export class GoToPoi {
  public static readonly type = ActionTypes.GoToPoi;
  
  public constructor(public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest) {
  }
}

/**
 * Add Poi With Position
 */
export class AddPoiWithPosition {
  public static readonly type = ActionTypes.AddPoiWithPosition;
  
  public constructor(public page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                     public image: FlatModels.ImageEntityModels.Image | null,
                     public text: string | null,
                     public name: string) {
  }
}

/**
 * Update Poi Position
 */
export class UpdatePoiPosition {
  public static readonly type = ActionTypes.UpdatePoiPosition;
  
  public constructor(public poi: FlatModels.PointOfInterestEntityModels.PointOfInterest) {
  }
}


/**
 * Set Edit Panel Overlay
 */
export class SetEditPanelOverlay {
  public static readonly type = ActionTypes.SetEditPanelOverlay;
  
  public constructor(public editPanelOverlay: boolean) {
  }
}


/**
 * Set Edit Panel Display
 */
export class SetEditPanelDisplay {
  public static readonly type = ActionTypes.SetEditPanelDisplay;
  
  public constructor(public editPanelDisplay: FlatModels.SlideAuthorModels.EditPanelDisplay,
                     public editPanelBulkEdit = false) {
  }
}


/**
 * Set Main Panel Display
 */
export class SetMainPanelDisplay {
  public static readonly type = ActionTypes.SetMainPanelDisplay;
  
  public constructor(public mainPanelDisplay: FlatModels.SlideAuthorModels.MainPanelDisplay) {
  }
}


/**
 * Set Is Splitter Moving
 */
export class SetIsSplitterMoving {
  public static readonly type = ActionTypes.SetIsSplitterMoving;
  
  public constructor(public isSplitterMoving: boolean) {
  }
}

// </editor-fold>